<template>
  <div class="holiday-event-add">
    <InfoContainer
      :infoTitle="InfoContainerConfig['infoTitle']"
      :contentConfig="InfoContainerConfig['infoContent']"
    >
      <template slot="basicInfo">
        <avue-form
          ref="basicInfo"
          v-model="basicInfoData"
          :option="eventAddOption"
        >
          <template slot="fileUplod">
              <div class="upload-container">
                <WordUpload
                  @showFileName="showFileNames"
                  fileMenuName="假期管理"
                  limit="1"
                  :plain="true"
                  :id="holidayId"
                />
                <div class="">
                  <template v-for="(item, index) in files">
                    <div class="file_wrapper" :key="index">
                      <a
                        class="file_button"
                        target="_blank"
                        :href="
                          isWord(item.fileUrl)
                            ? 'http://doc.taizhoujintou.com:18888/office/xdoc?doc=' +
                              item.fileUrl
                            : item.fileUrl"
                        type="text"
                        size="small"
                      >
                        {{ item.fileName }}
                      </a>
                      <i
                        @click="downLoadFile(item.id)"
                        class="el-icon-download del_icon"
                      ></i>
                      <i
                        @click="delFile(item.id, index, 'file')"
                        class="el-icon-circle-close del_icon"
                      ></i>
                    </div>
                  </template>
                </div>
              </div>
          </template>

          <template slot="unitMember">
            <div class="input-con">
              <el-input
                @focus="selectPersonClick"
                rows="5"
                type="textarea"
                placeholder="请选择员工内容"
                v-model="basicInfoData['unitMember']"
              >
              </el-input>
              <div class="event-tip">
                <i class="el-icon-warning"></i>
                <span class="warning-text">将自动向所选员工发送"假期调整"提醒消息</span>
              </div>
            </div>
          </template>
        </avue-form>
      </template>

      <div class="submit-con">
        <el-button type="primary" plain @click="deleteData" v-if="$route['query'] && $route['query']['holidayId']">删除事件</el-button>
        <el-button type="primary" @click="validData">保存</el-button>
      </div>
    </InfoContainer>

    <SelectPerson
      ref="selectperson"
      :checkUserList="checkUserList"
      :isOnly="false"
      :clear="false"
      @setPeople="setPeople"
    />    
  </div>
</template>
<script>
import { eventAddConfig } from './config.js'
import SelectPerson from "@/components/SelectPersonnel/person"
import InfoContainer from "@/components/infoContainer/infoContainer"
import WordUpload from "@/components/wordUpload/wordUpload"
import { downLoadTemplate } from "@/router/downLoadTem"
import * as dictionaries from "@/api/zd/dictionaries"
import { holidayDict, getHolidayEventDetail, addHolidayEvent, queryInventedId, deleteHolidayEvent} from "@/api/hr/holiday"
export default {
  name: 'HolidayEventAdd',
  data() {
    return {
      holidayId: '',
      files: [],
      baFileMenuId: '',
      basicInfoData: {},
      checkUserList: [],
      eventTypeAarray: [],
      eventAddOption: eventAddConfig(this.selectPersonClick),
      InfoContainerConfig: {
        infoTitle: '新增假期事件',
        infoContent: [{
          title: '基础信息',
          prop: 'basicInfo'
        }]
      }
    }
  },
  components: {
    WordUpload,
    InfoContainer,
    SelectPerson
  },
  watch: {
    '$route': {
      handler(newData, oldData) {
        // 编辑页
        if(newData['query']&&newData['query']['holidayId']){
          this.InfoContainerConfig['infoTitle'] = '编辑假期事件'
          this.holidayId = this.$route['query']['holidayId']
          // 查询数据赋值
          this.queryEventDetail(this.$route['query']['holidayId'])
        }else{
          this.$refs['basicInfo'].resetForm()
        }
      }
    },
    'basicInfoData.vacationType': {
      handler(newType) {
        if(newType == '纸质请假') {
          this.eventAddOption.column[1].display = true
        } else {
          this.eventAddOption.column[1].display = false
        }
      }
    }
  },
  mounted() {
    if(this.$route['query'] && this.$route['query']['holidayId']){
      this.InfoContainerConfig['infoTitle'] = '编辑假期事件'
      this.holidayId = this.$route['query']['holidayId']
      this.queryEventDetail(this.$route['query']['holidayId'])
    } else {
      // 获取虚拟ID
      this.getVirtualId()
      if(this.$route['query'] && this.$route['query']['addId']){
        this.$set(this.basicInfoData, "unitMember", this.$route['query']['userName'])
        this.checkUserList.push({
          id: this.$route['query']['addId'],
          realName: this.$route['query']['userName'],
          title: this.$route['query']['userName']
        })
      }
    }
    // this.getHolidayDic()
  },
  methods: {

    getVirtualId() {
      let self = this
      queryInventedId().then(res => {
        if(res['data']['code'] == 200){
          self.holidayId = res['data']['data']
        }
      })
    },

    // 查询假期事件数据
    queryEventDetail(id) {
      let self = this
      // 查询详细数据
      getHolidayEventDetail({id: id}).then(res => {
        if(res['data']['code'] == 200){
          // self.dialogTableVisible = true
          self.basicInfoData = res['data']['data']
          self.basicInfoData['unitMember'] = res['data']['data']['userName'].join(',')
          if(self.basicInfoData['validBeginTime'] !== '' && self.basicInfoData['validEndTime'] !== ''){
            self.basicInfoData['validTimeRange'] = [self.basicInfoData['validBeginTime'],self.basicInfoData['validEndTime']]
          }
          let userList = res['data']['data']['userId'].split(',')
          userList.map((item,index) => {
            self.checkUserList.push({
              id: item,
              realName: self.basicInfoData['userName'][index],
              title: self.basicInfoData['userName'][index]
            })
          })
          // 设置表单数据
          // self.basicInfoData['userString'] = self.changeArrayToString(res['data']['data']['userName']) 
          // 查询附件
          self.getFileMenuByName()
        }
      })
    },

    // 通过文件夹名称获取菜单
    getFileMenuByName() {
      dictionaries
        .getFileMenuByName({ fileMenuName:'假期管理' }).then((res) => {
          this.baFileMenuId = res.data.data.id
          this.getFileName()
        })
        .catch((res) => {
          console.log(res);
        });
    },

    getFileName() {
      let self = this
      let params = {
        fileOtherId: this.holidayId,
        baFileMenuId: this.baFileMenuId
      }
      dictionaries.findFileByOtherId(params).then((res) => {
        if(res['data']['data']['length'] > 0){
          self.files = res.data.data
        }
      }).catch((res) => {
        this.loading = false;
      });
    },

    getHolidayDic() {
      let self = this
      let dicArray = []
      holidayDict().then(res => {
        if(res['data']['code'] == '200'){
          res['data']['data'].map(item => {
            dicArray.push({
              dictValue: item,
              dictKey: item
            })
          })
          self.$refs['basicInfo'].updateDic('vacationType', dicArray);
        }
      })
    },

    selectPersonClick() {
      this.$refs.selectperson.showmode()
    },

    setPeople(val) {
      this.checkUserList = val
      this.getVisitPeople()
    },

    getVisitPeople() {
      let people = this.checkUserList.map((item) => {
        return item.realName;
      });
      let ids = this.checkUserList.map((item) => {
        return item.id;
      });
      this.$nextTick(() => {
        this.basicInfoData['unitMember'] = people.join(",");
        this.basicInfoData['userId'] = ids.join(",");
      });      
    },

    showFileNames(data) {
      this.files = data
    },

    downLoadFile(id) {
      downLoadTemplate("/api/file/down", {
        id,
      }).finally(() => {
        this.loading = false;
        this.$message({
          type: "success",
          message: "已下载",
        });
      });
    },

       //删除附件
    delFile(fileId, index, name) {
      this.$confirm("确定将附件删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          return dictionaries.deleteFile({
            fileId,
          });
        })
        .then(() => {
          this.files.splice(index, 1)
          // this.formData['files'].splice(index, 1);
          this.$message({
            type: "success",
            message: "操作成功!",
          });
        });
    },

    validData() {
      let self = this
      this.$refs['basicInfo'].validate((valid1,done1) => {
        if(valid1) {
          self.submitForm()
          done1()
        }
      })
    },

    submitForm() {
      let self = this
      let params = {
        vacationType: this.basicInfoData['vacationType'],
        vacationDay: this.basicInfoData['vacationDay'],
        vacationBeginTime: this.basicInfoData['vacationBeginTime'],
        vacationEndTime: this.basicInfoData['vacationEndTime'],
        vacationReason: this.basicInfoData['vacationReason'],
        userId: this.basicInfoData['userId']?this.basicInfoData['userId']:this.$route['query']['addId']
      }
      if(this.basicInfoData['id']){
        params['id'] = this.basicInfoData['id']
      }else{
        params['id'] = this.holidayId
      }
      if(this.basicInfoData['validTimeRange']['length']>0){
        params['validBeginTime'] = this.basicInfoData['validTimeRange'][0]
        params['validEndTime'] = this.basicInfoData['validTimeRange'][1]
      }
      // 2022/04/02 新增纸质请假类型
      if(this.basicInfoData['vacationTypes'] && this.basicInfoData['vacationTypes'] != ''){
        params['vacationType'] = this.basicInfoData['vacationTypes']
        params['recordType'] = 2
      }
      addHolidayEvent(params).then(res => {
        if(res['data']['code'] == 200){
          self.$message({
            type: "success",
            message: "提交成功",
          })
        }
        self.$router.go(-1)
      })
    },

    deleteData() {
      let self = this
      this.$confirm("是否删除该事件?", "操作确认", {
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteHolidayEvent({ids: self.holidayId}).then(res => {
            if(res['data']['code'] == '200'){
              self.$router.go(-1)
              self.$message({
                type: "success",
                message: "已删除"
              });
            }
          })
        })
        .catch((res) => {
          self.$message({
            type: "info",
            message: "已取消",
          });
        });      
    }

  }
}
</script>
<style lang="scss" scoped>
.holiday-event-add{
  .event-tip{
    color: #ffa217;
    font-size: 12px;
    line-height: 14px;
    margin-top: 10px;
    .el-icon-warning{
      color: #ffa217;
      font-size: 14px;
      line-height: 14px;
      margin-right: 5px;
    }
  }
  .submit-con{
    text-align: center;
    margin-bottom: 40px;
    button{
      width: 150px;
    }
  }
  a.file_button {
    font-size: 13px;
    color: #666;
  }
}
</style>